<template>
    <div class="edit-password">
        <MyTitle theTitle="修改密码"/>
        <div class="guarantee-respondent">
            <!--需要嵌套阿里修改密码页面-->
            <div id="edit-password-box">
                <iframe class="frame-style" :src="resetUrl"></iframe>
            </div>
        </div>
    </div>
</template>

<script>
    import MyTitle from '../../components/common/myTitle';

    export default {
        data() {
            return {
                resetUrl: ""
            }
        },
        components: {
            MyTitle,
        },
        methods: {
            initResetPasswordUrl: function () {
                this.resetUrl = process.env.VUE_APP_ALI_BASE_URL + "/app#/resetPwd";
            }
        },
        created() {
            this.initResetPasswordUrl();
        }
    }
</script>

<style lang="less" scoped>
    .edit-password, .guarantee-respondent {
        width: 100%;
        height: 100%;
    }

    #edit-password-box {
        width: 80%;
        margin-left: 10%;
        height: 100%;
    }

    .frame-style {
        width: 100%;
        min-height: 400px;
        border: 0;
    }

    #edit-password-box {
        text-align: center;
    }
</style>
